import { AxiosError } from "axios";
import axiosInstanceV2 from "../config/axios-v2-config";
import axiosInstance from "../config/axios-config";

const BASE_FREQUENCY_URL = "/v1/prescription-frequency";
const BASE_FREQUENCY_URL_V2 = "/v2/prescription-frequency";

export const getFrequencies = async (includeDeleted: boolean = false) => {
  try {
    // Patient page calls with no arg → soft-deleted rows are excluded by the backend.
    // Admin panel passes true to also load soft-deleted rows so they can be toggled back.
    const response = await axiosInstanceV2.get(BASE_FREQUENCY_URL_V2, {
      params: includeDeleted ? { include_deleted: true } : undefined,
    });
    if (response.status !== 200) {
      throw Error("Unable retrieve frequency names data");
    } else {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw Error("Unable retrieve frequency names data");
  }
};

export const setFrequencySoftDeleted = async (
  id: string,
  softDeleted: boolean
) => {
  try {
    const response = await axiosInstanceV2.patch(
      `${BASE_FREQUENCY_URL_V2}/${id}`,
      { soft_deleted: softDeleted }
    );
    if (response.status !== 200) {
      throw Error("Unable to update frequency");
    }
    return response.data;
  } catch (error) {
    console.error(error);
    if (error instanceof AxiosError) {
      const detail = error.response?.data?.detail;
      throw Error(detail || "Unable to update frequency");
    }
    throw Error("Unable to update frequency");
  }
};

export const addNewFrequency = async ({
  frequencyName,
  frequencyDescription,
  frequencyTranslation,
}: {
  frequencyName: string;
  frequencyDescription: string;
  frequencyTranslation: string;
}) => {
  try {
    const response = await axiosInstanceV2.post(BASE_FREQUENCY_URL_V2, {
      name: frequencyName,
      description: frequencyDescription,
      translation: frequencyTranslation,
    });
    if (response.status !== 201) {
      throw Error("Unable save frequency data");
    } else {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    // Surface the backend's error detail (e.g. 409 duplicate name) so the caller can toast it.
    if (error instanceof AxiosError) {
      const detail = error.response?.data?.detail;
      throw Error(detail || "Unable save frequency data");
    }
    throw Error("Unable save frequency data");
  }
};

export const updateFrequency = async (
  id: string,
  {
    frequencyName,
    frequencyDescription,
    frequencyTranslation,
  }: {
    frequencyName: string;
    frequencyDescription: string;
    frequencyTranslation: string;
  }
) => {
  try {
    const response = await axiosInstanceV2.patch(
      `${BASE_FREQUENCY_URL_V2}/${id}`,
      {
        name: frequencyName,
        description: frequencyDescription,
        translation: frequencyTranslation,
      }
    );
    if (response.status !== 200) {
      throw Error("Unable to update frequency");
    }
    return response.data;
  } catch (error) {
    console.error(error);
    // Surface the backend's error detail (e.g. 409 duplicate name) so the caller can toast it.
    if (error instanceof AxiosError) {
      const detail = error.response?.data?.detail;
      throw Error(detail || "Unable to update frequency");
    }
    throw Error("Unable to update frequency");
  }
};

export const deleteFrequency = async (id: string) => {
  try {
    const response = await axiosInstanceV2.delete(
      `${BASE_FREQUENCY_URL_V2}/${id}`
    );
    if (response.status !== 200 && response.status !== 204) {
      throw Error("Unable to delete frequency");
    } else {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw Error("Unable to delete frequency");
  }
};
